<template>
  <div>
    <v-tooltip
      v-if="disabled"
      bottom
    >
      <template v-slot:activator="{ on }">
        <v-card
          class="pr-2 d-flex flex-column justify-center cursor-no-drop height-100"
          v-on="on"
        >
          <div class="align-self-center py-1">
            <v-icon
              color="grey"
              x-large
            >
              mdi-plus
            </v-icon>
          </div>
          <div class="align-self-center py-1">
            <v-card-title
              class="grey--text text-h6 text-md-subtitle-1 font-weight-bold align-self-center"
            >
              Ajouter une culture
            </v-card-title>
          </div>
        </v-card>
      </template>
      Vous n'avez pas les autorisations
    </v-tooltip>
    <v-card
      v-else
      class="pr-2 d-flex flex-column justify-center height-100"
      @click="onAjouteCulture"
    >
      <div class="align-self-center py-1">
        <v-icon
          color="secondary"
          x-large
        >
          mdi-plus
        </v-icon>
      </div>
      <div class="align-self-center py-1">
        <v-card-title
          class="secondary--text text-h6 text-md-subtitle-1 font-weight-bold align-self-center"
        >
          Ajouter une culture
        </v-card-title>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AjoutCulture',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onAjouteCulture () {
      this.$emit('ajout-culture')
    }
  }
}
</script>

<style lang="scss" scoped>
.cursor-no-drop {
  cursor: no-drop;
}
.height-100 {
  height: 100%;
}
</style>
